<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div class="title">Nova Transação</div>
        <div @click="close" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form @submit.prevent="save" class="form">
        <label>Data</label>
        <input v-model="date" type="date" :class="{ error : error.includes('date') }" />
        <div v-if="error.includes('date')" class="hint">você esqueceu a data</div>

        <label>Produto</label>
        <select v-model="product" :class="{ error : error.includes('product') }">
          <option :value="null">Selecione o produto</option>
          <option v-for="p in productOptions" :key="p.id" :value="p.id">{{ p.label }}</option>
        </select>
        <div v-if="error.includes('product')" class="hint">você esqueceu o produto</div>

        <label>Cliente</label>
        <Autocomplete v-model="customer" :list="listCustomers" placeholder="Cliente" :class="{ error : error.includes('user') }" />
        <div v-if="error.includes('user')" class="hint">você esqueceu o cliente</div>

        <label>Valor</label>
        <money v-bind="formatMoney" v-model="amount" :class="{ error : error.includes('amount') }"></money>
        <div v-if="error.includes('amount')" class="hint">você esqueceu o valor</div>

        <label class="switch" style="margin-top: 10px;">
          <input v-model="createSignature" type="checkbox">
          <span class="slider"></span>
          <span class="text" style="margin-left: 0px;">Gerar assinatura</span>
        </label>

        <div v-if="errorMsg" class="hint">{{ errorMsg }}</div>
        <button type="submit" class="button-save" style="margin-top: 30px">
          <i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span>
        </button>
      </form>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { create } from '../api/transaction'
import { getGrouped } from '../api/product'
import { getAll as getCustomers } from '../api/customer'
import Autocomplete from './Autocomplete'

export default {
  name: 'TransactionCreate',
  components: { Autocomplete },
  props: ['close'],
  data () {
    return {
      loading: false,
      error: [],
      errorMsg: null,
      date: null,
      product: null,
      customer: null,
      amount: '',
      createSignature: false,
      groupedProducts: [],
      customers: [],
      formatMoney: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    productOptions () {
      const options = []
      for (const prod of this.groupedProducts) {
        for (const per of (prod.periods || [])) {
          const name = per.periodName || per.period_name || 'Período'
          const dias = per.dias != null ? per.dias : null
          const periodLabel = dias != null ? `${name} - (${dias} dias)` : name
          options.push({
            id: per.id,
            label: `${prod.name} - ${periodLabel}`,
            price: per.price
          })
        }
      }
      return options
    },
    listCustomers () {
      return this.customers.map(x => ({
        id: x.userId,
        name: x.name,
        detail: `${x.login} | ${x.phone}`
      }))
    }
  },
  async mounted () {
    this.date = new Date().toISOString().split('T')[0]
    try {
      const endDate = new Date().toISOString().split('T')[0]
      const [groupedProducts, customers] = await Promise.all([
        getGrouped(),
        getCustomers('2000-01-01', endDate)
      ])
      this.groupedProducts = groupedProducts || []
      this.customers = customers || []
    } catch (error) {
      logger.error(error)
    }
  },
  methods: {
    async save () {
      try {
        this.loading = true
        this.error = []
        this.errorMsg = null

        if (!this.date) this.error.push('date')
        if (!this.product) this.error.push('product')
        if (!this.customer) this.error.push('user')
        if (!this.amount || Number(this.amount) <= 0) this.error.push('amount')
        if (this.error.length > 0) return

        await create(this.customer, this.product, Number(this.amount), this.date, this.createSignature)
        this.$message.success('Transação criada com sucesso', { duration: 3000 })
        this.close()
      } catch (error) {
        const data = error.response ? error.response.data : {}
        if (data.error === 'Validation error') {
          this.error = data.fields || []
        } else if (data.error === 'Permission denied') {
          this.errorMsg = 'Sem permissão para criar transação.'
        } else {
          this.errorMsg = 'Erro interno! Tente novamente.'
          logger.error(error)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
